// Returns only the data array — used by hooks that don't need pagination metadata.
export const selector = (data) => data?.data;

// Returns { data, pagination } — use this when the caller needs pagination info.
export const paginatedSelector = (data) => ({
  data: data?.data,
  pagination: data?.pagination ?? null,
});
